import React from 'react'

import type { UploadProps } from '@fourthwall/components'
import { Fieldset, Toasts, Upload } from '@fourthwall/components'
import { fileToBase64 } from '@fourthwall/utils/dist/file'
import { getRejectionErrors } from '@utils/dropzone'

import { RemovableUpload, UploadedImage } from '../../../../../../components'
import { useTierContext } from '../../hooks/useTierContext'
import { FormFields } from '../../providers/TierProvider/types'
import * as S from './styled'

export const Image = () => {
  const { form, isLoading } = useTierContext()

  const handleFileDrop = async (files?: File[]) => {
    const file = files?.[0]

    if (file) {
      const base64 = await fileToBase64(file)

      form.setFieldValue(FormFields.image, base64)
      form.setFieldValue(FormFields.imageFile, file)
      form.setFieldValue(FormFields.removeImage, false)
    }
  }

  const handleFileDropRejected: UploadProps['onFileDropRejected'] = (rejectedFiles) => {
    getRejectionErrors(rejectedFiles, {
      'file-too-large': 'File is larger than 10 megabytes',
    }).forEach((rejection) => {
      Toasts.notify(rejection)
    })
  }

  const renderUpload = () => {
    const image = form.values.image

    if (image) {
      return (
        <RemovableUpload
          onRemove={() => {
            form.setFieldValue(FormFields.image, undefined)
            form.setFieldValue(FormFields.imageFile, undefined)
            form.setFieldValue(FormFields.removeImage, true)
          }}
        >
          <UploadedImage objectFit="contain" image={image} />
        </RemovableUpload>
      )
    }

    return (
      <Upload
        accept={{
          'image/*': [],
        }}
        iconSize={20}
        orientation="horizontal"
        title=""
        maxSize={10485760}
        onFileDrop={handleFileDrop}
        disabled={isLoading}
        onFileDropRejected={handleFileDropRejected}
      />
    )
  }

  return (
    <Fieldset.Row>
      <Fieldset.Item>
        <S.ImageInputContainer>
          <S.UploadContainer>{renderUpload()}</S.UploadContainer>
          Tier image (optional)
        </S.ImageInputContainer>
      </Fieldset.Item>
    </Fieldset.Row>
  )
}
